/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { isEmpty } from "lodash";

/* components */
import PagesForm from "../PagesPage/PagesForm";
import Page from "../../shared/Page";

import GetItem from "../../../helpers/dataProviders/getItem";

class IntegrationFormWrapper extends Component {
	constructor(props) {
		super(props);
		this.indefiniteArticle = "An";
		this.label = "Integration";
		this.id = props.match.params.id ? props.match.params.id : 0;

		this.initialPageId = "5bfc77d83dde002fec72a49c";

		this.state = {
			item: null,
			appetizePageId: null,
			appetizeParams: encodeURIComponent(`{"firestorePageDocumentName": "${this.initialPageId}"}`),
			showPreview: false,
			moduleId: null,
			appetizePaused: false,
		};
	}

	shouldComponentUpdate(nextProps) {
		const { match } = this.props;
		let { id } = match.params;
		let newId = nextProps.match.params.id;
		if (id !== newId) {
			if (newId) {
				this.props.showLoading();
				this.props.clearFormApi();
				GetItem(`/integrations/${newId}`)
					.then(data => {
						this.setState({
							item: data.data,
							showPreview: true,
							appetizeParams: encodeURIComponent(`{"firestorePageDocumentName": "${newId}"}`),
							moduleId: data.data.moduleId,
						});
						if (this.props.hasFormApi) {
							this.props.formApi.setValues(data.data);
						}
						this.props.hideLoading();
					})
					.catch(() => {
						this.props.hideLoading();
					});
			} else {
				this.props.showLoading();
				setTimeout(() => {
					this.setState({
						item: null,
						appetizePageId: null,
						showPreview: false,
						moduleId: null,
						appetizeParams: encodeURIComponent(`{"firestorePageDocumentName": "${this.initialPageId}"}`),
					});
					this.props.hideLoading();
				}, 200);
			}
		}

		return true;
	}

	submitForm(values, submitHandler, id = "") {
		const { createItem, copyItem, updateItem, type } = this.props;
		switch (type) {
			case "new":
				createItem(values, submitHandler);
				break;
			case "copy":
				copyItem(values, submitHandler);
				break;
			case "update":
				updateItem(values, submitHandler, id);
				break;
			default:
				break;
		}
	}

	renderCreateForm = () => {
		if (this.state.item === null) {
			GetItem(`/apps/${this.props.appKey}`).then(data => {
				this.setState({ item: { themeId: data.data.primaryThemeId } });
			});
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<PagesForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						buttonLabel={`Create ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePageId={this.setAppetizePageId}
						setAppetizePause={this.setAppetizePause}
						appKey={this.props.appKey}
						initialValues={this.state.item}
						moduleType="identity"
						actionType="new"
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderCopyForm = () => {
		if (this.state.item === null) {
			if (!isEmpty(this.props.items)) {
				this.getCorrectIntegration(this.props.match.params.id, this.props.items);
			}
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<PagesForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler)}
						initialValues={this.state.item}
						buttonLabel={`Create ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePageId={this.setAppetizePageId}
						setAppetizePause={this.setAppetizePause}
						appKey={this.props.appKey}
						moduleType="identity"
						actionType="copy"
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	renderUpdateForm = () => {
		if (this.state.item === null) {
			if (!isEmpty(this.props.items)) {
				this.getCorrectIntegration(this.props.match.params.id, this.props.items);
			}
		}
		return (
			<div className="ta-center">
				{this.state.item ? (
					<PagesForm
						cultures={this.props.cultures}
						onSubmit={(values, submitHandler) => this.submitForm(values, submitHandler, this.state.item.id)}
						initialValues={this.state.item}
						buttonLabel={`Update ${this.label}`}
						getFormApi={this.props.getFormApi}
						hasFormApi={this.props.hasFormApi}
						setAppetizePageId={this.setAppetizePageId}
						setAppetizePause={this.setAppetizePause}
						appKey={this.props.appKey}
						moduleType="identity"
						actionType="update"
						entity="integrations"
						id={this.state.item.id}
					/>
				) : (
					"Loading..."
				)}
			</div>
		);
	};

	getCorrectIntegration = (id, items) => {
		const item = items.find(i => i.id === id);

		if (item.moduleType === "OAuthIntegration") {
			GetItem(`/oauth/${id}`).then(data => {
				this.setState({ item: data.data });
			});
		} else {
			GetItem(`/integrations/${id}`).then(data => {
				this.setState({ item: data.data });
			});
		}
	};

	setAppetizePageId = (appetizePageId, moduleId) => {
		if (this.state.appetizePageId === null) {
			this.setState({
				appetizePageId,
			});
		}
		if (moduleId && this.state.moduleId !== moduleId) {
			this.setState({
				moduleId,
				showPreview: true,
			});
		} else if (!moduleId) {
			this.setState({
				moduleId,
				showPreview: false,
			});
		}
	};

	setAppetizePause = appetizePaused => {
		if (appetizePaused !== this.state.appetizePaused) {
			this.setState({ appetizePaused });
		}
	};

	render() {
		let content = "Loading";
		switch (this.props.type) {
			case "new":
				content = this.renderCreateForm();
				break;
			case "copy":
				content = this.renderCopyForm();
				break;
			case "update":
				content = this.renderUpdateForm();
				break;
			default:
				break;
		}
		return (
			<Page title="My Pages">
				<div className="page-contents">
					<div className="page-builder" style={{ display: "block" }}>
						{content}
					</div>
				</div>
			</Page>
		);
	}
}

IntegrationFormWrapper.propTypes = {
	type: PropTypes.string,
	items: PropTypes.array,
	cultures: PropTypes.array,
	createItem: PropTypes.func,
	copyItem: PropTypes.func,
	updateItem: PropTypes.func,
	match: PropTypes.object,
	getFormApi: PropTypes.func,
	hasFormApi: PropTypes.bool,
	appKey: PropTypes.string,
	apps: PropTypes.array,
	formApi: PropTypes.object,
	showLoading: PropTypes.func,
	hideLoading: PropTypes.func,
	clearFormApi: PropTypes.func,
};

export default withRouter(IntegrationFormWrapper);
